import { useMutation, useQueryClient } from "@tanstack/react-query";
import { postPatientPackageStart } from "apis";
import { getPatientOverviewQueryKey } from "../use-get-patient-overview";

const usePostPatientPackageStart = () => {
  const queryClient = useQueryClient();
  return useMutation(postPatientPackageStart, {
    onSuccess: ({ success }, { data }) => {
      if (success) {
        const { patient_oid } = data;
        return queryClient.invalidateQueries(
          getPatientOverviewQueryKey(patient_oid)
        );
      }
    },
  });
};
export default usePostPatientPackageStart;
